import { Spinner } from '@smartsash/ui';
import { createFileRoute } from '@tanstack/react-router';

import styles from './_dashboard.module.css';

import { requireWorkspace } from '@/router/guards';
import DashboardLayout from '@/ui/layouts/DashboardLayout/DashboardLayout';
import { DeferredServiceRequestToasts } from '@/ui/layouts/DashboardLayout/DeferredServiceRequestToasts';
import { DeferredStreamDock } from '@/ui/layouts/DashboardLayout/DeferredStreamDock';

export const Route = createFileRoute('/_dashboard')({
  // The root guard already authenticates and awaits session restore (HS-859); this one only picks
  // the shell — Installer workspace or admin panel (HS-1630) — and keeps each in its own routes.
  beforeLoad: requireWorkspace,
  component: DashboardRouteLayout,
  // The root guard awaits `auth.restore()`, so the first navigation is genuinely pending while
  // the cookie session is probed. Render the spinner there rather than inside the layout — the
  // component no longer has a resolving state to inspect.
  pendingComponent: DashboardPending,
});

function DashboardPending() {
  return (
    <div className={styles.loading}>
      <Spinner size={32} />
    </div>
  );
}

function DashboardRouteLayout() {
  return (
    <>
      <DashboardLayout />
      {/* HS-1548: lazily loaded after first paint; renders nothing. */}
      <DeferredServiceRequestToasts />
      {/* HS-1218: the watched stream and its mini player, kept across navigation. */}
      <DeferredStreamDock />
    </>
  );
}
